const customLoadingStyle = {
  loading: {
    display: 'block',
    margin: 0,
    position: 'center'
  }
};

export default customLoadingStyle;
